"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { IconButton } from "../../buttons";
import { Overlay } from "../overlay/overlay";
import { Toolbar } from "../../toolbars";
import CloseIcon from "@travel/shared/assets/icons/icon-close-circle.svg";
import styles from "./dialog.module.css";
export var CloseDialogIcon = CloseIcon;
export function Dialog(_a) {
    var _b;
    var className = _a.className, _c = _a.size, size = _c === void 0 ? "md" : _c, header = _a.header, title = _a.title, subtitle = _a.subtitle, content = _a.content, _d = _a.hideClose, hideClose = _d === void 0 ? true : _d, showClose = _a.showClose, classes = _a.classNames, fill = _a.fill, _e = _a.fillHeightMobile, fillHeightMobile = _e === void 0 ? false : _e, desiredWidth = _a.desiredWidth, _f = _a.closeIcon, closeIcon = _f === void 0 ? CloseDialogIcon : _f, rest = __rest(_a, ["className", "size", "header", "title", "subtitle", "content", "hideClose", "showClose", "classNames", "fill", "fillHeightMobile", "desiredWidth", "closeIcon"]);
    var hasToolbar = !!header || !!title || !!subtitle;
    return (_jsx(Overlay, __assign({}, rest, { className: classNames(styles["dialog"], className, (_b = {},
            _b[styles[size]] = true,
            _b[styles["fill"]] = fill,
            _b[styles["fill-height-mobile"]] = fillHeightMobile,
            _b[styles["has-toolbar"]] = hasToolbar,
            _b)), classNames: {
            content: classNames(styles["content"], classes === null || classes === void 0 ? void 0 : classes.content),
            inner: classNames(styles["inner"], classes === null || classes === void 0 ? void 0 : classes.inner),
            enter: styles["dialog-enter"],
            enterActive: styles["dialog-enter-active"],
            exit: styles["dialog-exit"],
            exitActive: styles["dialog-exit-active"],
        }, hideClose: hideClose, closeIcon: closeIcon, contentStyle: desiredWidth
            ? {
                width: "100%",
                maxWidth: desiredWidth,
            }
            : undefined, content: function (actions, value) { return (_jsxs(_Fragment, { children: [(!!title || !!header) && (_jsx(Toolbar, { secondaryActions: _jsx(IconButton, { className: styles["close"], icon: _jsx(CloseIcon, {}), onClick: actions.close }), children: header ? (header) : (_jsxs("div", { children: [_jsx("div", { className: styles["title"], children: title }), _jsx("div", { className: styles["subtitle"], children: subtitle })] })) })), showClose ? (_jsx("div", { className: styles["top"], children: _jsx(IconButton, { className: styles["close"], theme: "text", icon: _jsx(CloseIcon, {}), onClick: actions.close }) })) : null, typeof content === "function" ? content(actions, value) : content] })); } })));
}
